function _pipeP(f, g) {
  return function () {
    var ctx = this;
    return f.apply(ctx, arguments).then(function (x) {
      return g.call(ctx, x);
    });
  };
}
module.exports = _pipeP;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_pipeP.js
// module id = 917
// module chunks = 0